
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1703',
  depVersions: {
  "customer-portal-app": "static-1.1703",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.446",
  "data-fetching-client": "static-1.9492",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.405",
  "growth-payments-core": "static-1.24764",
  "head-dlb": "static-1.4841",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5408",
  "hs-test-utils": "static-1.7820",
  "hub-http": "static-1.6035",
  "hub-http-shared-msw-handlers": "static-1.9506",
  "hubspot-dlb": "static-2.1806",
  "hubspot-prosemirror": "static-1.17642",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11247",
  "I18n": "static-7.1574",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6287",
  "payment-link-components": "static-1.22975",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6753",
  "quartz-core": "static-1.5972",
  "react": "static-7.180",
  "react-colorpicker": "static-2.10024",
  "react-dlb": "static-1.73",
  "react-utils": "static-2.5187",
  "rich-text-lib": "static-1.19492",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17680",
  "ui-components-test-utils": "static-1.5385",
  "UIComponents": "static-3.8194",
  "foundations-assets": "static-1.4651",
  "foundations-components": "static-1.7549",
  "foundations-theming": "static-1.4226",
  "foundations-theming-specialty": "static-1.1942",
  "framer-motion": "static-1.67",
  "history": "static-4.47",
  "metrics-js": "static-1.9436",
  "PortalIdParser": "static-2.367",
  "portals-platform-lib": "static-1.558",
  "quartz-config": "static-1.531",
  "quartz-routing": "static-1.183",
  "quick-fetch": "static-1.3749",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16464",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7956",
  "styled-components": "static-2.85",
  "tanstack-table": "static-1.50",
  "ui-addon-draggable": "static-3.4580",
  "ui-addon-react-router-dom": "static-1.9361",
  "usage-tracker": "static-1.7149",
  "usage-tracker-anonymous": "static-1.5566",
  "usage-tracker-core": "static-1.6999",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3243",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3030",
  "quartz-webpack": "static-1.2977",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.77",
  "customer-data-objects": "static-1.7464",
  "frontend-preferences-client": "static-1.7739",
  "laboratory-lib": "static-3.6975",
  "onboarding-scopes": "static-1.6278",
  "rpc-client-utils": "static-1.4449",
  "ui-addon-opt": "static-4.8199",
  "HeadJS": "static-2.713",
  "hs-test-utils-bend-plugin": "static-1.2931",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "ts-schema": "static-1.3918",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7468",
  "cssUtils": "static-1.736",
  "customer-data-ui-utilities": "static-1.9638",
  "HubStyle": "static-2.11555",
  "knowledge-content-types": "static-1.8383",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.428",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.484",
  "ui-addon-emoji-picker": "static-1.9703",
  "ui-addon-i18n": "static-1.10955",
  "ui-business-units-lib": "static-1.8844",
  "ui-shepherd-react": "static-3.9962",
  "video-components-external": "static-1.10608",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4141",
  "commerce-tours-lib": "static-1.5739",
  "customer-data-properties": "static-1.50837",
  "getting-started-shared-tasks": "static-1.17923",
  "growth-onboarding-reliability": "static-1.4901",
  "onboarding-tours": "static-1.16280",
  "reference-resolvers-lite": "static-1.7909",
  "sales-checkout-service-client": "static-1.3483",
  "ui-addon-iframeable": "static-1.8859",
  "user-context": "static-1.4914",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.798",
  "hubspotter-http": "static-1.4492",
  "icons": "static-2.623",
  "mobile-manifest-mixins": "static-1.486",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.428",
  "quartz-head": "static-1.418",
  "quartz-test": "static-1.428",
  "quartz-tracking": "static-1.132",
  "ui-fonts": "static-1.509",
  "usage-tracker-container": "static-1.7139",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9242",
  "data-token-picker": "static-1.16063",
  "FileManagerLib": "static-1.38568",
  "property-translator": "static-1.5227",
  "atom": "static-1.4884",
  "merchandise-lib": "static-1.259",
  "purchase-motions-components": "static-1.5500",
  "salesImages": "static-1.521",
  "SharedI18nStrings": "static-1.180",
  "foundations-components-test-utils": "static-1.5032",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.94",
  "ui-images": "static-2.1096",
  "bend-plugin-foundations-components": "static-1.3818",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "trellis-assets": "static-1.1246",
  "bend-plugin-foundations-theming": "static-1.2709",
  "foundations-theming-base": "static-1.3211",
  "stylex": "static-1.27",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5563",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4289",
  "react-flip-move": "static-1.65",
  "bender-build-tools": "static-1.2956",
  "inbound-db-properties-service-client": "static-1.3689",
  "superstore": "static-1.4585",
  "feedback-loader": "static-1.28880",
  "ai-components-ui-library": "static-1.8380",
  "ui-addon-video-player": "static-1.8511",
  "ui-coaching-tips": "static-1.27979",
  "sassPrefix": "static-1.152",
  "react-dnd-compat": "static-1.4435",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2302",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7975",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4464",
  "content-media-composition-data-lib": "static-1.11507",
  "content-media-compositions": "static-2.15514",
  "idb-keyval": "static-1.39",
  "immer": "static-1.33",
  "immerable": "static-1.3970",
  "magpie-lib": "static-1.5409",
  "magpie-types": "static-1.4869",
  "media-bridge-lib": "static-1.18586",
  "video-data-lib": "static-1.34266",
  "commerce-products-lib": "static-1.8897",
  "crm-message-bus": "static-1.42405",
  "growth-data-modal": "static-1.5173",
  "hubspot-apollo-client": "static-1.4696",
  "onboarding-tours-client": "static-1.4494",
  "calling-global-api": "static-1.63717",
  "calling-internal-common": "static-1.31109",
  "calling-lifecycle-internal": "static-1.65099",
  "calling-lifecycle-messages": "static-1.57393",
  "conditional-properties-service-client": "static-1.3637",
  "crm-links": "static-1.6081",
  "customer-data-objects-ui-components": "static-1.12824",
  "customer-data-property-utils": "static-1.7892",
  "external-options-client-types": "static-1.3998",
  "file-manager-components": "static-1.22928",
  "framework-data-schema-resolvers": "static-1.6688",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.493",
  "inbound-db-meta-service-client": "static-1.3431",
  "inbounddb-objects-service-types": "static-1.4062",
  "meetings-icalendar-utils-lib": "static-1.448",
  "multi-currency-client-types": "static-1.3531",
  "object-builder-ui-client": "static-1.48023",
  "pipeline-validation-client-types": "static-1.3800",
  "property-value-citations": "static-1.1451",
  "pulse": "static-1.328",
  "smart-property-lib": "static-1.5962",
  "tiered-pricing": "static-1.849",
  "ui-addon-form-validation": "static-1.10809",
  "growth-onboarding-confetti": "static-1.2887",
  "growth-onboarding-next-action-utils": "static-1.1325",
  "navigation-components": "static-1.17311",
  "onboarding-tours-utils": "static-1.346",
  "ui-shepherd-tracker": "static-1.7343",
  "ui-universal-auth": "static-1.8718",
  "batch-promise": "static-1.1366",
  "navigation-messaging": "static-1.6638",
  "getting-started-shared-tasks-store": "static-1.17041",
  "hubspotter-http-shared-msw-handlers": "static-1.9504",
  "audio-components": "static-1.5631",
  "FileManagerCore": "static-1.38427",
  "FileManagerImages": "static-1.36079",
  "video-components": "static-1.12611",
  "foundations-components-legacy": "static-1.574",
  "growth-monetization-service-types": "static-1.4328",
  "nav-client-types": "static-1.2172",
  "purchase-motions-api": "static-1.5503",
  "self-service-api": "static-1.10051",
  "signup-constants": "static-1.18435",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3729",
  "usage-tracker-public": "static-1.6960",
  "chatspot-core": "static-1.20382",
  "chirp-fetch": "static-1.1697",
  "ContentUtils": "static-1.67661",
  "copilot-toolkit": "static-1.10567",
  "growth-onboarding-feedback-components": "static-1.6398",
  "hls.js": "static-1.34",
  "reactive-lib": "static-1.540",
  "simple-logging-lib": "static-1.2865",
  "commerce-permissions": "static-1.573",
  "customer-data-tracking": "static-1.6697",
  "products-iframe-lib": "static-1.7354",
  "products-ui-components-shared-msw-handlers": "static-1.9888",
  "hubspot-apollo-cache": "static-1.155",
  "calling-error-reporting": "static-1.31115",
  "shared-worker-versioning": "static-1.10853",
  "calling-usage-tracker": "static-1.6355",
  "voice-sms-access-library": "static-1.284",
  "conversations-skeleton-state": "static-1.7062",
  "location-customization-utils-lib": "static-1.8602",
  "crm-pipelines-api-client-types": "static-1.3978",
  "framework-builder-read-service-client": "static-1.3847",
  "framework-data-schema-quick-fetch": "static-1.6593",
  "persist-promise": "static-1.3523",
  "directed-graph": "static-1.751",
  "event-emitter": "static-1.762",
  "breeze-intelligence-kit": "static-1.5340",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9589",
  "fsm": "static-1.3546",
  "policy-lib": "static-1.6601",
  "react-tinymce": "static-1.54657",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9652",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53783",
  "tinymce-plugins": "static-1.56897",
  "tinymce-themes": "static-1.55753",
  "growth-onboarding-next-action-components": "static-1.1353",
  "user-context-client": "static-1.4477",
  "unified-auth-core-lib": "static-1.513",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4347",
  "video-embed": "static-1.35100",
  "content-icons-ui": "static-1.2158",
  "social-insights-client-types": "static-1.21391",
  "eligibility-engine-service-types": "static-1.3010",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4621",
  "integrations-lib": "static-1.15458",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4102",
  "calling-orchestration-schema": "static-1.35061",
  "crm-record-cards-service-types": "static-1.3460",
  "highcharts": "static-8.99",
  "trellis-story-utils": "static-1.4336",
  "storybook-react": "static-1.28",
  "hub-http-contrib": "static-1.2858",
  "interframe": "static-3.4604",
  "tinymce-data": "static-1.39868",
  "ui-addon-sales-email": "static-1.5028",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.12057",
  "layout-dnd-utils": "static-1.11032",
  "react-codemirror": "static-1.10441",
  "ui-brand-identity-lib": "static-1.13949",
  "NamespacedHubStyle": "static-2.8910",
  "outpost": "static-1.4018",
  "flux-actions": "static-1.310",
  "integrations-error-boundary-lib": "static-1.12873",
  "integrations-tracking-lib": "static-1.5403",
  "native-integrations-shared-strings": "static-1.7603",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10186",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67736",
  "layout-data-lib": "static-1.9357",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2814",
  "advanced-menus-core": "static-1.14833",
  "advanced-menus-lib": "static-1.11806",
  "ExportDialog": "static-6.10201",
  "ui-memberships-settings-lib": "static-1.33464",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14832",
  "simple-menus-lib": "static-1.16349"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1703",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.446",
  "data-fetching-client": "/data-fetching-client/static-1.9492",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.405",
  "growth-payments-core": "/growth-payments-core/static-1.24764",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5408",
  "hs-test-utils": "/hs-test-utils/static-1.7820",
  "hub-http": "/hub-http/static-1.6035",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9506",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17642",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11247",
  "I18n": "/I18n/static-7.1574",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6287",
  "payment-link-components": "/payment-link-components/static-1.22975",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6753",
  "quartz-core": "/quartz-core/static-1.5972",
  "react": "/react/static-7.180",
  "react-colorpicker": "/react-colorpicker/static-2.10024",
  "react-dlb": "/react-dlb/static-1.73",
  "react-utils": "/react-utils/static-2.5187",
  "rich-text-lib": "/rich-text-lib/static-1.19492",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17680",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5385",
  "UIComponents": "/UIComponents/static-3.8194",
  "foundations-assets": "/foundations-assets/static-1.4651",
  "foundations-components": "/foundations-components/static-1.7549",
  "foundations-theming": "/foundations-theming/static-1.4226",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1942",
  "framer-motion": "/framer-motion/static-1.67",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9436",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "portals-platform-lib": "/portals-platform-lib/static-1.558",
  "quartz-config": "/quartz-config/static-1.531",
  "quartz-routing": "/quartz-routing/static-1.183",
  "quick-fetch": "/quick-fetch/static-1.3749",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16464",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7956",
  "styled-components": "/styled-components/static-2.85",
  "tanstack-table": "/tanstack-table/static-1.50",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4580",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9361",
  "usage-tracker": "/usage-tracker/static-1.7149",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5566",
  "usage-tracker-core": "/usage-tracker-core/static-1.6999",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3243",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3030",
  "quartz-webpack": "/quartz-webpack/static-1.2977",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.77",
  "customer-data-objects": "/customer-data-objects/static-1.7464",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7739",
  "laboratory-lib": "/laboratory-lib/static-3.6975",
  "onboarding-scopes": "/onboarding-scopes/static-1.6278",
  "rpc-client-utils": "/rpc-client-utils/static-1.4449",
  "ui-addon-opt": "/ui-addon-opt/static-4.8199",
  "HeadJS": "/HeadJS/static-2.713",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2931",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "ts-schema": "/ts-schema/static-1.3918",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7468",
  "cssUtils": "/cssUtils/static-1.736",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9638",
  "HubStyle": "/HubStyle/static-2.11555",
  "knowledge-content-types": "/knowledge-content-types/static-1.8383",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.428",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9703",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10955",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8844",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9962",
  "video-components-external": "/video-components-external/static-1.10608",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4141",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5739",
  "customer-data-properties": "/customer-data-properties/static-1.50837",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17923",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4901",
  "onboarding-tours": "/onboarding-tours/static-1.16280",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7909",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3483",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8859",
  "user-context": "/user-context/static-1.4914",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.798",
  "hubspotter-http": "/hubspotter-http/static-1.4492",
  "icons": "/icons/static-2.623",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.486",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.428",
  "quartz-head": "/quartz-head/static-1.418",
  "quartz-test": "/quartz-test/static-1.428",
  "quartz-tracking": "/quartz-tracking/static-1.132",
  "ui-fonts": "/ui-fonts/static-1.509",
  "usage-tracker-container": "/usage-tracker-container/static-1.7139",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9242",
  "data-token-picker": "/data-token-picker/static-1.16063",
  "FileManagerLib": "/FileManagerLib/static-1.38568",
  "property-translator": "/property-translator/static-1.5227",
  "atom": "/atom/static-1.4884",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "purchase-motions-components": "/purchase-motions-components/static-1.5500",
  "salesImages": "/salesImages/static-1.521",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5032",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.94",
  "ui-images": "/ui-images/static-2.1096",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3818",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.1246",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2709",
  "foundations-theming-base": "/foundations-theming-base/static-1.3211",
  "stylex": "/stylex/static-1.27",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5563",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4289",
  "react-flip-move": "/react-flip-move/static-1.65",
  "bender-build-tools": "/bender-build-tools/static-1.2956",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3689",
  "superstore": "/superstore/static-1.4585",
  "feedback-loader": "/feedback-loader/static-1.28880",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8380",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8511",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27979",
  "sassPrefix": "/sassPrefix/static-1.152",
  "react-dnd-compat": "/react-dnd-compat/static-1.4435",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2302",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7975",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4464",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11507",
  "content-media-compositions": "/content-media-compositions/static-2.15514",
  "idb-keyval": "/idb-keyval/static-1.39",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3970",
  "magpie-lib": "/magpie-lib/static-1.5409",
  "magpie-types": "/magpie-types/static-1.4869",
  "media-bridge-lib": "/media-bridge-lib/static-1.18586",
  "video-data-lib": "/video-data-lib/static-1.34266",
  "commerce-products-lib": "/commerce-products-lib/static-1.8897",
  "crm-message-bus": "/crm-message-bus/static-1.42405",
  "growth-data-modal": "/growth-data-modal/static-1.5173",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4696",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4494",
  "calling-global-api": "/calling-global-api/static-1.63717",
  "calling-internal-common": "/calling-internal-common/static-1.31109",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65099",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57393",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3637",
  "crm-links": "/crm-links/static-1.6081",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12824",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7892",
  "external-options-client-types": "/external-options-client-types/static-1.3998",
  "file-manager-components": "/file-manager-components/static-1.22928",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6688",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.493",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3431",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4062",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.448",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3531",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48023",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3800",
  "property-value-citations": "/property-value-citations/static-1.1451",
  "pulse": "/pulse/static-1.328",
  "smart-property-lib": "/smart-property-lib/static-1.5962",
  "tiered-pricing": "/tiered-pricing/static-1.849",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10809",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2887",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1325",
  "navigation-components": "/navigation-components/static-1.17311",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.346",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7343",
  "ui-universal-auth": "/ui-universal-auth/static-1.8718",
  "batch-promise": "/batch-promise/static-1.1366",
  "navigation-messaging": "/navigation-messaging/static-1.6638",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17041",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9504",
  "audio-components": "/audio-components/static-1.5631",
  "FileManagerCore": "/FileManagerCore/static-1.38427",
  "FileManagerImages": "/FileManagerImages/static-1.36079",
  "video-components": "/video-components/static-1.12611",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.574",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4328",
  "nav-client-types": "/nav-client-types/static-1.2172",
  "purchase-motions-api": "/purchase-motions-api/static-1.5503",
  "self-service-api": "/self-service-api/static-1.10051",
  "signup-constants": "/signup-constants/static-1.18435",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3729",
  "usage-tracker-public": "/usage-tracker-public/static-1.6960",
  "chatspot-core": "/chatspot-core/static-1.20382",
  "chirp-fetch": "/chirp-fetch/static-1.1697",
  "ContentUtils": "/ContentUtils/static-1.67661",
  "copilot-toolkit": "/copilot-toolkit/static-1.10567",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6398",
  "hls.js": "/hls.js/static-1.34",
  "reactive-lib": "/reactive-lib/static-1.540",
  "simple-logging-lib": "/simple-logging-lib/static-1.2865",
  "commerce-permissions": "/commerce-permissions/static-1.573",
  "customer-data-tracking": "/customer-data-tracking/static-1.6697",
  "products-iframe-lib": "/products-iframe-lib/static-1.7354",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9888",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.155",
  "calling-error-reporting": "/calling-error-reporting/static-1.31115",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10853",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6355",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.284",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7062",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8602",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3978",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3847",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6593",
  "persist-promise": "/persist-promise/static-1.3523",
  "directed-graph": "/directed-graph/static-1.751",
  "event-emitter": "/event-emitter/static-1.762",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5340",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9589",
  "fsm": "/fsm/static-1.3546",
  "policy-lib": "/policy-lib/static-1.6601",
  "react-tinymce": "/react-tinymce/static-1.54657",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9652",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53783",
  "tinymce-plugins": "/tinymce-plugins/static-1.56897",
  "tinymce-themes": "/tinymce-themes/static-1.55753",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1353",
  "user-context-client": "/user-context-client/static-1.4477",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.513",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4347",
  "video-embed": "/video-embed/static-1.35100",
  "content-icons-ui": "/content-icons-ui/static-1.2158",
  "social-insights-client-types": "/social-insights-client-types/static-1.21391",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3010",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4621",
  "integrations-lib": "/integrations-lib/static-1.15458",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4102",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35061",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "highcharts": "/highcharts/static-8.99",
  "trellis-story-utils": "/trellis-story-utils/static-1.4336",
  "storybook-react": "/storybook-react/static-1.28",
  "hub-http-contrib": "/hub-http-contrib/static-1.2858",
  "interframe": "/interframe/static-3.4604",
  "tinymce-data": "/tinymce-data/static-1.39868",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5028",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.12057",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11032",
  "react-codemirror": "/react-codemirror/static-1.10441",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13949",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8910",
  "outpost": "/outpost/static-1.4018",
  "flux-actions": "/flux-actions/static-1.310",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12873",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5403",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7603",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10186",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67736",
  "layout-data-lib": "/layout-data-lib/static-1.9357",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2814",
  "advanced-menus-core": "/advanced-menus-core/static-1.14833",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11806",
  "ExportDialog": "/ExportDialog/static-6.10201",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33464",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14832",
  "simple-menus-lib": "/simple-menus-lib/static-1.16349"
}
};
